import { FilterModel } from 'types/models/filter'

export const MAX_FACETED_ITEMS_COUNT = 500

export const FILTER_PRICE_FROM: keyof FilterModel = 'priceFrom'
export const FILTER_PRICE_TO: keyof FilterModel = 'priceTo'

export const CATALOG_FETCH_DEBOUNCE_AMOUNT = 500
export const CATALOG_FILTERS_SEARCH_DEBOUNCE_AMOUNT = 300
export const CATALOG_FILTER_CHANGE_DEBOUNCE_AMOUNT = 300

export const CATALOG_MAIN_ROUTE = '/catalog'
export const CATALOG_BRAND_ROUTE = '/brand/'

export const CURRENCY_FALLBACK = 'EUR'
export const LOCALE_FALLBACK = 'en_GB'
